module.exports = __webpack_public_path__ + "img/icon-vip-yellow@3x.d19a9f25.png";